// Lightweight toast notification component for cart actions
import React, { useEffect, useState } from 'react';
import { Check, Info, X } from 'lucide-react';
import '../../styles/toast.css';

const Toast = ({ message, type = 'success', duration = 2000, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const showTimer = setTimeout(() => setIsVisible(true), 10);

    // Start exit animation before removal
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, duration - 300);

    // Remove component
    const removeTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, [duration, onClose]);

  // Batch 34 C5: an INFO toast (the plants ride-along sentence) wears an
  // info mark, never the error X.
  let icon = <X size={18} aria-hidden="true" />;
  if (type === 'success') icon = <Check size={18} aria-hidden="true" />;
  else if (type === 'info') icon = <Info size={18} aria-hidden="true" />;

  return (
    <div
      className={`ff-toast ff-toast--${type} ${isVisible && !isExiting ? 'ff-toast--visible' : ''} ${isExiting ? 'ff-toast--exiting' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="ff-toast-icon">{icon}</span>
      <span className="ff-toast-message">{message}</span>
    </div>
  );
};

export default Toast;
